import { Link } from "react-router-dom";

export default function NotFound() {
  const links = [
    { to: "/", label: "トップページ", icon: "ri-home-line" },
    { to: "/services", label: "サービス", icon: "ri-service-line" },
    { to: "/cases", label: "事例", icon: "ri-building-line" },
    { to: "/contact", label: "お問い合わせ", icon: "ri-mail-line" },
  ];

  return (
    <section className="relative min-h-[700px] md:min-h-[800px] flex items-center overflow-hidden">
      <img
        src="images/404.jpg"
        alt="404"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0"></div>
      <div className="relative z-10 w-full pt-24">
        <div className="mx-auto max-w-3xl px-4 md:px-10 text-center text-background-50 fade-up">
          <p className="text-primary-300 text-xs tracking-[0.4em] uppercase mb-4 text-slate-900">404 Not Found</p>
          <h1 className="font-heading text-5xl md:text-7xl mb-4 text-slate-900">404</h1>
          <p className="text-background-100/90 text-lg md:text-xl mb-10 text-slate-900">
            お探しのページが見つかりませんでした。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-14">
            <Link
              to="/"
              className="bg-accent-500 hover:bg-accent-600 text-background-50 font-medium px-6 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-home-line"></i>
              トップページへ戻る
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-2xl mx-auto">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="bg-background-100 border border-background-200 rounded-lg p-5 hover:border-primary-300 cursor-pointer transition-colors flex flex-col items-center gap-2"
              >
                <i className={`${l.icon} text-2xl text-primary-600`}></i>
                <span className="text-sm text-foreground-800">{l.label}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}